// src/pages/MerchandiseDetailPage.js

import React from 'react';
import { useParams } from 'react-router-dom';
import { useQuery, gql } from '@apollo/client';
import StripeDash from '../components/StripeDash';
import PublicMerchandiseItem from '../components/PublicMerchandiseItem';  // Import the MerchandiseItem component
//import backgroundImage from '../assets/images/background.jpg'; // Import the image
const GET_MERCH_PAGE = gql`
  query GetMerchPage($input: MerchInput!) {
    getMerchPage(input: $input) {
      id
      title
      description
      items {
        id
        title
        description
        price
        attributes
        mainImage
        additionalImages
        merchandisePageId
      }
    }
  }
`;

const PublicMerchandiseDetailPage = ({ merchandisePageId: propPageId }) => {
 
  const { id: urlId } = useParams();
  const pageId = propPageId || urlId;

  const { loading, error, data } = useQuery(GET_MERCH_PAGE, {
    variables: { input: { id: pageId } },  // Pass 'input' object as required by the schema
  });

  if (loading) return <p>Loading...</p>;
  if (error) return <p>Error: {error.message}</p>;

  const { title, description, items } = data.getMerchPage;
  //const backgroundimage = `https://gigabout.com.au/merchimages/${id}/background.jpg`

  return (
    <div
    style={{
      position: 'relative',
      minHeight: '100vh',
      
      backgroundRepeat: 'repeat',
      backgroundSize: 'cover',
    }}
  >
    <div
      style={{
        position: 'absolute',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        backgroundColor: 'rgba(0, 0, 0, 0.886)', // Adjust the color and transparency
        zIndex: 1,
      }}
    />
    <div style={{ position: 'relative', zIndex: 2 }}>
      <h1 style={{color: 'white'}}>{title}</h1>
      <p style={{color: 'white'}}>{description}</p>
      <p style={{color: 'white'}}>This is a sample page. You can't buy anything yet</p>
      <h2 style={{color: 'white'}}>Products</h2>
      <div 
        style = {{paddingLeft: 20,
                  paddingRight: 20,
        }}>
      <div 
        style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))',
          gap: '16px',
        }}
      >
        {items.map((item) => (
          <PublicMerchandiseItem key={item.id} item={item} onAddToCart={(item) => {/* handle add to cart */}} />
        ))}
      </div>
    </div>
    
    </div>
    
    </div>
    
  );
};

export default PublicMerchandiseDetailPage;
